import { __awaiter, __generator } from "tslib";
import { getDigest } from '@office-start/digest-utility';
import { utf8Encode } from '@office-start/text-encoding-utility';
import { getSimplePersistence } from './getSimplePersistence';
export function getDbAndKeyTuple(userId, collectionName, collectionVersion, key, hashKey) {
    return __awaiter(this, void 0, void 0, function () {
        var initPromises, values, db, tempKey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initPromises = [
                        getSimplePersistence(userId, collectionName, collectionVersion),
                    ];
                    if (hashKey) {
                        initPromises.push(getDigest(crypto.subtle, key, userId, function (toEncode) {
                            return utf8Encode(toEncode);
                        }));
                    }
                    return [4 /*yield*/, Promise.all(initPromises)];
                case 1:
                    values = _a.sent();
                    db = values[0];
                    tempKey = key;
                    if (values.length > 1) {
                        tempKey = values[1];
                    }
                    return [2 /*return*/, [db, tempKey]];
            }
        });
    });
}
//# sourceMappingURL=getDbAndKeyTuple.js.map